var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert"},[_c('div',{staticClass:"alert__linel"}),_c('div',{staticClass:"alert__text"},[_vm._v(_vm._s(_vm.data))]),_c('div',{staticClass:"alert__liner"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28258eb6","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/AddPurchase/components/DisContent.vue
// module id = 1184
// module chunks = 1